import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { IActionFeed, selectActionFeed } from './actionFeed';
import { IEntityReducer } from 'core/reducers/entities';
import { parseAction } from './action';


const feed = selectActionFeed;
const entity = (state:RootState) => state.entity.present;

export const selectActionCurrent = createSelector([entity, feed], (entity: IEntityReducer, feed: IActionFeed) => {
  return parseAction(entity, feed.feed[feed.index]?.actionId);
});
